import { types } from './auth.types';


// login

export const sendLoginFormRequest = (data) => ({
    type: types.SEND_LOGIN_FORM_REQUEST,
    payload: data,
});

export const sendLoginFormSuccess = (payload) => ({
    type: types.SEND_LOGIN_FORM_SUCCESS,
    payload,
});

export const sendLoginFormError = (payload) => ({
    type: types.SEND_LOGIN_FORM_ERROR,
    payload,
});

// login-otp

export const sendLoginOtpFormRequest = () => ({
    type: types.SEND_LOGIN_OTP_FORM_REQUEST,
});

export const sendLoginOtpFormSuccess = (payload) => ({
    type: types.SEND_LOGIN_OTP_FORM_SUCCESS,
    payload,
});

export const sendLoginOtpFormError = (payload) => ({
    type: types.SEND_LOGIN_OTP_FORM_ERROR,
    payload,
});


//other

export const receiveAuth0Success = (payload) => ({
    type: types.RECEIVE_AUTH0_SUCCESS,
    payload,
});

export const clearAuthMutualData = () => ({
    type: types.CLEAR_AUTH_MUTUAL_DATA,
});

export const updateToken = (payload) => ({
    type: types.UPDATE_TOKEN,
    payload,
});

export const clearSession = () => ({
    type: types.CLEAR_SESSION,
});
